<template>
  <div class="dropdown" v-bind:class="{ 'is-active' : isOpen }" v-on-clickaway="cancel">
    <div class="dropdown-trigger" @click="toggleIsOpen">
      <button class="button" aria-haspopup="true" aria-controls="dropdown-menu">
        <span class="icon">
          <font-awesome-icon icon="filter" />
        </span>
        <span class="icon is-small">
          <font-awesome-icon icon="angle-down" />
        </span>
      </button>
    </div>
    <div class="dropdown-menu" id="dropdown-menu" role="menu">
      <div class="dropdown-content">
        <!-- Types -->
        <label v-for="type in types.types" :key="type.id" class="checkbox dropdown-item">
          <input :id="type.id" :value="type.id" type="checkbox" v-model="newSelectedTypes" @change="categoryClicked">
          {{$t(type.id)}}
        </label>
        <hr class="dropdown-divider-top"/>

        <!-- Select All Categories -->
        <div class="category-selection">
          <label v-if="categoryNames.length" class="checkbox dropdown-item">
            <input id="selectAll" type="checkbox" v-model="selectAll" @change="selectAllChanged">
            (Select All)
          </label>

          <!-- Categories -->
          <label v-for="cat in categoryNames" :key="cat" class="checkbox dropdown-item">
            <input :id="cat" :value="cat" type="checkbox" v-model="newSelectedCategories" @change="categoryClicked">
            {{cat}}
          </label>
        </div>

        <!-- Buttons -->
        <hr class="dropdown-divider-bottom">
        <div class="dropdown-item">
          <div style="justify-content: center" class="field is-grouped">
            <p class="control">
              <button class="button" @click="ok">OK</button>
            </p>
            <p class="control">
              <button class="button" @click="cancel">Cancel</button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<i18n src="../i18n/foodItem-types.i18n.json"></i18n>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { mixin as clickaway } from 'vue-clickaway';
import i18nMixin from '@/mixins/i18n';
import Types from '../foodItem-types';

export default {
  name: 'filter-selector',
  mixins: [clickaway, i18nMixin],
  props: {
    selectedTypes: {
      default: [],
    },
    selectedCategories: {
      default: [],
    },
  },
  data() {
    return {
      isOpen: false,
      newSelectedTypes: this.selectedTypes,
      newSelectedCategories: this.selectedCategories,
      selectAll: false,
    };
  },
  methods: {
    toggleIsOpen() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.newSelectedTypes = this.selectedTypes;
        this.newSelectedCategories = this.selectedCategories;
        this.updateSelectAll();
      }
    },
    ok() {
      this.$emit('ok', this.newSelectedTypes, this.newSelectedCategories);
      this.isOpen = false;
    },
    cancel() {
      this.newSelectedTypes = this.selectedTypes.slice(0);
      this.newSelectedCategories = this.selectedCategories.slice(0);
      this.isOpen = false;
    },
    selectAllChanged() {
      if (this.selectAll) {
        this.newSelectedCategories = this.categoryNames.slice(0);
      } else {
        this.newSelectedCategories = [];
      }
    },
    categoryClicked() {
      this.updateSelectAll();
    },
    updateSelectAll() {
      this.selectAll = (this.newSelectedCategories.length === this.categoryNames.length);
    },
  },
  computed: {
    categoryNames() {
      return this.$store.getters.categoryNames;
    },
    types() {
      return Types;
    },
  },
  components: {
    'font-awesome-icon': FontAwesomeIcon,
  },
};
</script>

<style lang="sass" scoped>

.category-selection
  max-height: 10.5rem
  overflow-y: auto

.dropdown-divider-copy
  background-color: #dbdbdb
  border: none
  display: block
  height: 1px
  margin: 0.5rem 0

.dropdown-divider-top
  @extend .dropdown-divider-copy
  margin-bottom: 0

.dropdown-divider-bottom
  @extend .dropdown-divider-copy
  margin-top: 0

</style>




// WEBPACK FOOTER //
// src/components/FilterSelector.vue